import { Injectable } from '@angular/core';

@Injectable()
export class ExtendedSearchListService {
    private savedSort: {
        [objectType: string]: {
            Column: string;
            Reverse: boolean;
        };
    } = {};

    private savedFilter: {
        [objectType: string]: {
            filterType;
        };
    } = {};

    getSavedSort(objectType) {
        if (this.savedSort.hasOwnProperty(objectType)) return this.savedSort[objectType];
    }

    setSavedSort(objectType, sort) {
        this.savedSort[objectType] = Object.assign({}, sort);
    }

    getSavedFilter(objectType) {
        if (this.savedFilter.hasOwnProperty(objectType)) return this.savedFilter[objectType];
    }

    setSavedFilter(objectType, filter) {
        this.savedFilter[objectType] = Object.assign(filter);
    }
}
